import { PropsWithChildren } from "react";
import { Text, TextProps } from "@chakra-ui/react";

export const StatHeading = ({
  children,
  ...props
}: PropsWithChildren<TextProps>) => (
  <Text
    textStyle="body2"
    fontWeight="semibold"
    color="grey.500"
    noOfLines={1}
    w="100%"
    {...props}
  >
    {children}
  </Text>
);

export default StatHeading;
